export const calculateSolarPanelSqft = (count: number) => {
  const panelWidth = 1.65; // m
  const panelHeight = 0.992; // m
  const panelSqft = panelWidth * panelHeight;
  const sqm2sqft = 10.764;

  return panelSqft * count * sqm2sqft;
};
